/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gh-no-entry',
  templateUrl: 'no-entry.component.html',
  styleUrls: ['no-entry.component.scss'],
})
export class NoEntryComponent {
  @Input() label: string;
  @Input() size: string = '100%';
}
